import DivisionEditor from './DivisionEditor';
import useEventContext from '@hooks/useEventContext';
import DivisionVisualizer from '@components/molecules/DivisionVisualizer';
import SubmitGeneralEventInfoFAB from './SubmitGeneralEventInfoFAB';

export default function DivisionManagerPage() {
    const { isEventAdmin } = useEventContext();

    return isEventAdmin ? (
        <div>
            <DivisionEditor />
            <SubmitGeneralEventInfoFAB />
        </div>
    ) : (
        <DivisionVisualizer />
    );
}
